export default __webpack_public_path__ + "static/media/logo.98740f5b.png";